<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-text>
            <v-alert :value="error" type="error" outline>{{ errorMessage }}</v-alert>
            <v-alert :value="success" type="success" outline>La contraseña se cambió exitosamente. Redireccionando en 5 segundos</v-alert>
            <form @submit.prevent="resetPassword">
              <v-text-field name="password" label="Contraseña nueva" v-model="password" type="password" required loading>
                <v-progress-linear
                  slot="progress" :value="progress" :color="color" height="2"></v-progress-linear>
              </v-text-field>
              <v-text-field name="password" label="Confirmar contraseña"  v-model="passwordConfirm" type="password"
                required :error-messages="confirmErrors"></v-text-field>
              <v-btn type="submit">Enviar</v-btn>
            </form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>

</template>
<script>

export default {
  data () {
    return {
      error: '',
      success: '',
      errorMessage: '',
      password: '',
      passwordConfirm: '',
      passwordResetPath: '/password_resetconfirm',
      token: this.$route.params.token
    }
  },

  computed: {
    confirmErrors () {
      if (this.passwordConfirm && (this.password !== this.passwordConfirm)) {
        return ['La nueva contraseña no coincide con la confirmación']
      }
      return []
    },
    progress () {
      return Math.min(100, this.password.length * 12.5)
    },
    color () {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
    }
  },
  methods: {
    resetPassword () {
      const resetPath = `${this.passwordResetPath}/?token=${this.token}`
      if (this.isValidForm()) {
        const payload = this.getPayload()
        this.axios
          .post(resetPath, payload)
          .then(() => {
            this.error = false
            this.success = true
            this.cleanForm()
            const self = this
            setTimeout(function () {
              self.$router.push({
                name: 'dashboard'
              })
            }, 5000)
          })
          .catch((error) => {
            if (error && error.response && error.response.status === 400) {
              this.setError(error.response.data.password[0])
            } else {
              this.setError('Error de conexión con el servidor')
            }
          })
      }
    },
    setError (message) {
      this.errorMessage = message
      this.error = true
    },
    getPayload () {
      return {
        password: this.password,
        token: this.token
      }
    },
    isValidForm () {
      if (this.progress !== 100) {
        this.setError('Ingrese una contraseña con al menos 8 caracteres')
        return false
      }
      return true
    },
    cleanForm () {
      this.password = ''
      this.passwordConfirm = ''
    }
  }
}
</script>
